import { render } from "./approveNodeModal.vue?vue&type=template&id=508f0208"
import script from "./approveNodeModal.vue?vue&type=script&lang=js"
export * from "./approveNodeModal.vue?vue&type=script&lang=js"

import "./approveNodeModal.vue?vue&type=style&index=0&id=508f0208&lang=scss"

import exportComponent from "/Users/luke/Documents/contility/server/src/views/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__